import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const AccountPageWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const Card = styled('section')<{ theme?: TTheme }>`
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    border-radius: 16px;
    padding: 24px;
`
